(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3bc1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3bc1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fDzGn", function(module, exports) {




(function() {
    var crypt = (parcelRequire("gbRXI")), utf8 = (parcelRequire("86bhY")).utf8, isBuffer = (parcelRequire("Ek5Fh")), bin = (parcelRequire("86bhY")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    module.exports = function(message, options) {
        if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();

});
parcelRegister("gbRXI", function(module, exports) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("86bhY", function(module, exports) {
var $5e57a4026a45f095$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $5e57a4026a45f095$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($5e57a4026a45f095$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = $5e57a4026a45f095$var$charenc;

});

parcelRegister("Ek5Fh", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($07935211e1a6d237$var$isBuffer(obj) || $07935211e1a6d237$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $07935211e1a6d237$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $07935211e1a6d237$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $07935211e1a6d237$var$isBuffer(obj.slice(0, 0));
}

});


const $781bdad29cc3f0c5$var$client_name = 'web';
const $781bdad29cc3f0c5$var$secret = 'f46d0c0603206b2f1515462e57284132';
const $781bdad29cc3f0c5$var$base_url = 'https://www.36bom.com/api/';
class $781bdad29cc3f0c5$export$9f633d56d7ec90d3 {
    constructor(success, errorMessage, data){
        this.success = success;
        this.errorMessage = errorMessage;
        this.data = data;
    }
    static from_json(jsonString) {
        return new $781bdad29cc3f0c5$export$9f633d56d7ec90d3(jsonString.success, jsonString.error, jsonString.data);
    }
    is_successful() {
        return this.success;
    }
    get_error_message() {
        return this.errorMessage;
    }
    get_data() {
        return this.data;
    }
}

function $781bdad29cc3f0c5$var$get_signature(inputs) {
    const keys = Array.from(inputs.keys()).sort();
    let buildup = $781bdad29cc3f0c5$var$secret;
    for (let key of keys)buildup += inputs.get(key);
    const md5 = (parcelRequire("fDzGn"));
    return md5(buildup);
}
function $781bdad29cc3f0c5$var$build_headers(inputs) {
    const signature = $781bdad29cc3f0c5$var$get_signature(inputs);
    return {
        'CLIENT': $781bdad29cc3f0c5$var$client_name,
        'SIGNATURE': signature,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
    };
}
async function $781bdad29cc3f0c5$export$3988ae62b71be9a3(inputs, service, endpoint) {
    const headers = $781bdad29cc3f0c5$var$build_headers(inputs);
    let url = $781bdad29cc3f0c5$var$base_url + service + '.php' + '?' + 'method=' + endpoint;
    for(let i = 0; i < inputs.length; i++)url += '&' + inputs[i].key + '=' + inputs[i].value;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: headers
        });
        // Check if the request was successful (status in the 200-299 range)
        if (!response.ok) throw new Error('Network response was not ok: ' + response.statusText);
        // Parse the response body as JSON
        let result = $781bdad29cc3f0c5$export$9f633d56d7ec90d3.from_json(await response.json());
        if (!result.success) throw new Error('Network response was not ok: ' + result.get_error_message());
        return result;
    } catch (error) {
        console.error('Fetch error:', error);
        return new $781bdad29cc3f0c5$export$9f633d56d7ec90d3(false, error.message, null);
    }
}
async function $781bdad29cc3f0c5$export$299ba2dee77727e9(inputs, service, endpoint) {
    const headers = $781bdad29cc3f0c5$var$build_headers(inputs);
    let url = $781bdad29cc3f0c5$var$base_url + service + '.php';
    inputs.set('method', endpoint);
    const body = JSON.stringify(Object.fromEntries(inputs));
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: body
        });
        // Check if the request was successful (status in the 200-299 range)
        if (!response.ok) throw new Error('Network response was not ok: ' + response.statusText);
        // Parse the response body as JSON
        let result = $781bdad29cc3f0c5$export$9f633d56d7ec90d3.from_json(await response.json());
        if (!result.success) throw new Error('Network response was not ok: ' + result.get_error_message());
        return result;
    } catch (error) {
        console.error('Fetch error:', error);
        return new $781bdad29cc3f0c5$export$9f633d56d7ec90d3(false, error.message, null);
    }
}


class $831a9d1272c745f5$export$942479cbbfd2c573 {
    constructor(name, loggedBy, url){
        this.name = name;
        this.loggedby = loggedBy;
        this.url = url;
    }
    static from_json(json) {
        return new $831a9d1272c745f5$export$942479cbbfd2c573(json.name, json.loggedBy, json.url);
    }
    get_name() {
        return this.name;
    }
    get_logged_by() {
        return this.loggedby;
    }
    get_url() {
        return this.url;
    }
}


class $16c7cf10179da9aa$export$c959ddfb5bf9a14a {
    constructor(name, chapterCount, chapters, loggedBy){
        this.name = name;
        this.chapterCount = chapterCount;
        this.chapters = chapters;
        this.loggedBy = loggedBy;
    }
    static from_json(json) {
        const chapters = [];
        json.chapters.forEach((chapter)=>chapters.push((0, $831a9d1272c745f5$export$942479cbbfd2c573).from_json(chapter)));
        return new $16c7cf10179da9aa$export$c959ddfb5bf9a14a(json.name, json.chapterCount, chapters, json.loggedBy);
    }
    get_name() {
        return this.name;
    }
    get_chapter_count() {
        return this.chapterCount;
    }
    get_chapters() {
        return this.chapters;
    }
    get_logged_by() {
        return this.loggedBy;
    }
}


class $cacb811c2624b4c2$export$66faccf4f494e531 {
    constructor(bookCount, chapterCount, name, chapterLabelSingular, chapterLabelPlural, books, loggedBy){
        this.bookCount = bookCount;
        this.chapterCount = chapterCount;
        this.name = name;
        this.chapterLabelSingular = chapterLabelSingular;
        this.chapterLabelPlural = chapterLabelPlural;
        this.books = books;
        this.loggedBy = loggedBy;
    }
    static from_json(json) {
        const books = [];
        json.books.forEach((book)=>books.push((0, $16c7cf10179da9aa$export$c959ddfb5bf9a14a).from_json(book)));
        return new $cacb811c2624b4c2$export$66faccf4f494e531(json.bookCount, json.chapterCount, json.name, json.chapterLabelSingular, json.chapterLabelPlural, books, json.loggedBy);
    }
    get_book_count() {
        return this.bookCount;
    }
    get_chapter_count() {
        return this.chapterCount;
    }
    get_name() {
        return this.name;
    }
    get_chapter_label_singular() {
        return this.chapterLabelSingular;
    }
    get_chapter_label_plural() {
        return this.chapterLabelPlural;
    }
    get_books() {
        return this.books;
    }
    get_logged_by() {
        return this.loggedBy;
    }
}



class $3156f55a56827da0$export$9a1c4632481ec248 {
    constructor(name, userId, chaptersRead, completedDate){
        this.name = name;
        this.userId = userId;
        this.chaptersRead = chaptersRead;
        this.completedDate = completedDate;
    }
    static from_json(json) {
        return new $3156f55a56827da0$export$9a1c4632481ec248(json.name, json.userId, json.chaptersRead, json.completedDate);
    }
    static from_user(user) {
        return new $3156f55a56827da0$export$9a1c4632481ec248(user.get_name(), user.get_id(), 0, null);
    }
    get_name() {
        return this.name;
    }
    get_chapters_read() {
        return this.chaptersRead;
    }
    get_completed_date() {
        return this.completedDate;
    }
    get_user_id() {
        return this.userId;
    }
}


class $2fc2aa21826ea61d$export$a50dcf13e7b62e9d {
    constructor(id, name, startDate, endDate, work, challengers){
        this.id = id;
        this.name = name;
        this.startDate = startDate;
        this.endDate = endDate;
        this.work = work;
        this.challengers = challengers;
    }
    static from_json(json) {
        const work = (0, $cacb811c2624b4c2$export$66faccf4f494e531).from_json(json.work);
        const challengers = [];
        json.challengers.forEach((challenger)=>challengers.push((0, $3156f55a56827da0$export$9a1c4632481ec248).from_json(challenger)));
        return new $2fc2aa21826ea61d$export$a50dcf13e7b62e9d(json.serverId, json.name, json.startDate, json.endDate, work, challengers);
    }
    get_id() {
        return this.id;
    }
    get_name() {
        return this.name;
    }
    get_start_date() {
        return this.startDate;
    }
    get_end_date() {
        return this.endDate;
    }
    get_work() {
        return this.work;
    }
    get_challengers() {
        return this.challengers;
    }
}


function $375579c1a20da0b9$var$display_error(error_msg) {
    const timeline_container = document.getElementById('timeline-container');
    timeline_container.style.display = 'none';
    const progress_container = document.getElementById('progress-container');
    progress_container.style.display = 'none';
    const error_container = document.getElementById('error-container');
    const msg = document.getElementById('error-message');
    msg.innerText = error_msg;
    error_container.style.display = 'block';
}
function $375579c1a20da0b9$var$build_timeline(challenge) {
    const start = challenge.get_start_date();
    const end = challenge.get_end_date();
    const current = Date.now();
    const days_left = Math.ceil((end - current) / 86400000);
    const percent_complete = Math.ceil((current - start) / (end - start) * 100);
    const timeline_container = document.getElementById('timeline-container');
    timeline_container.style.display = 'block';
    const days_container = document.createElement('div');
    days_container.className = 'days-display';
    const days_display = document.createElement('span');
    days_display.innerText = days_left + ' days left';
    days_container.appendChild(days_display);
    timeline_container.appendChild(days_container);
    const bar_container = document.createElement('div');
    bar_container.className = 'bar-container';
    timeline_container.appendChild(bar_container);
    const progress = document.createElement('div');
    progress.className = 'timeline-bar';
    progress.style.width = percent_complete + '%';
    bar_container.appendChild(progress);
    timeline_container.appendChild(document.createElement('hr'));
}
function $375579c1a20da0b9$var$build_progress(challenge) {
    const progress_container = document.getElementById('progress-container');
    progress_container.style.display = 'block';
    const total = challenge.get_work().get_chapter_count();
    const sorted = challenge.get_challengers().sort((a, b)=>b.get_chapters_read() - a.get_chapters_read());
    sorted.forEach((challenger)=>{
        const logged = challenger.get_chapters_read();
        const complete = challenger.get_completed_date() !== null;
        const name_container = document.createElement('div');
        name_container.className = 'name-display';
        const name_display = document.createElement('span');
        let text = challenger.get_name();
        if (complete) text = text + ' - Completed!';
        else text = text + ' - ' + logged + '/' + total + ' Read';
        name_display.innerText = text;
        name_container.appendChild(name_display);
        progress_container.appendChild(name_container);
        const bar_container = document.createElement('div');
        bar_container.className = 'bar-container';
        progress_container.appendChild(bar_container);
        let percent_complete = Math.ceil(logged / total * 100);
        if (percent_complete > 100) percent_complete = 100;
        const progress = document.createElement('div');
        progress.className = 'progress-bar';
        progress.style.width = percent_complete + '%';
        bar_container.appendChild(progress);
    });
}
async function $375579c1a20da0b9$var$initialize() {
    const challenge_result = await (0, $781bdad29cc3f0c5$export$3988ae62b71be9a3)(new Map(), 'challenges', 'get_current_challenge');
    if (!challenge_result.is_successful()) {
        console.error(challenge_result.get_error_message());
        $375579c1a20da0b9$var$display_error("There is no current challenge or there was an unknown error");
    } else {
        const challenge = (0, $2fc2aa21826ea61d$export$a50dcf13e7b62e9d).from_json(challenge_result.get_data());
        $375579c1a20da0b9$var$build_timeline(challenge);
        $375579c1a20da0b9$var$build_progress(challenge);
    }
}
$375579c1a20da0b9$var$initialize();

})();
//# sourceMappingURL=index.js.map
